// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_period.ml",
      80,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "Period"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    });

const Tax = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_period.ml",
      124,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Period"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    });

const Control = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_period.ml",
      166,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Period"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_period.ml",
      206,
      12
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Period"
        ]]
    });

const Period = Caml_module.init_mod([
      "proto/taxapis/gen/buhta_tax_control_v1_period.ml",
      237,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.tax.control.v1.Period";
}

function make(yearOpt, kindOpt, param) {
  const year = yearOpt !== undefined ? yearOpt : 0;
  const kind = kindOpt !== undefined ? kindOpt : "not_set";
  return {
          year: year,
          kind: kind
        };
}

const merge_year = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "year",
            "year"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_oneof_kind__Month = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.int32_int
        ]));

const merge_oneof_kind__Quarter = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.int32_int
        ]));

const merge_oneof_kind__Half = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.int32_int
        ]));

function merge(t1, t2) {
  const match = t1.kind;
  const match$1 = t2.kind;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Quarter") {
      if (typeof match$1 === "string" || match$1.NAME !== "Quarter") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Quarter",
          VAL: Curry._2(merge_oneof_kind__Quarter, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Month") {
      if (typeof match$1 === "string" || match$1.NAME !== "Month") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Month",
          VAL: Curry._2(merge_oneof_kind__Month, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Half" && !(typeof match$1 === "string" || match$1.NAME !== "Half")) {
      tmp = {
        NAME: "Half",
        VAL: Curry._2(merge_oneof_kind__Half, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
          year: Curry._2(merge_year, t1.year, t2.year),
          kind: tmp
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "year",
                    "year"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
                      {
                        hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                              [
                                2,
                                "month",
                                "month"
                              ],
                              Ocaml_protoc_plugin__Spec.int32_int,
                              [
                                (function (v) {
                                    return {
                                            NAME: "Month",
                                            VAL: v
                                          };
                                  }),
                                (function (param) {
                                    if (typeof param === "string") {
                                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                MEL_EXN_ID: Stdlib.Invalid_argument,
                                                _1: "Cannot destruct given oneof"
                                              });
                                    }
                                    if (param.NAME === "Month") {
                                      return param.VAL;
                                    }
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                              MEL_EXN_ID: Stdlib.Invalid_argument,
                                              _1: "Cannot destruct given oneof"
                                            });
                                  })
                              ]
                            ]),
                        tl: {
                          hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                [
                                  3,
                                  "quarter",
                                  "quarter"
                                ],
                                Ocaml_protoc_plugin__Spec.int32_int,
                                [
                                  (function (v) {
                                      return {
                                              NAME: "Quarter",
                                              VAL: v
                                            };
                                    }),
                                  (function (param) {
                                      if (typeof param === "string") {
                                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                                  _1: "Cannot destruct given oneof"
                                                });
                                      }
                                      if (param.NAME === "Quarter") {
                                        return param.VAL;
                                      }
                                      throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                MEL_EXN_ID: Stdlib.Invalid_argument,
                                                _1: "Cannot destruct given oneof"
                                              });
                                    })
                                ]
                              ]),
                          tl: {
                            hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                                  [
                                    4,
                                    "half",
                                    "half"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int32_int,
                                  [
                                    (function (v) {
                                        return {
                                                NAME: "Half",
                                                VAL: v
                                              };
                                      }),
                                    (function (param) {
                                        if (typeof param === "string") {
                                          throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                    MEL_EXN_ID: Stdlib.Invalid_argument,
                                                    _1: "Cannot destruct given oneof"
                                                  });
                                        }
                                        if (param.NAME === "Half") {
                                          return param.VAL;
                                        }
                                        throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                                  MEL_EXN_ID: Stdlib.Invalid_argument,
                                                  _1: "Cannot destruct given oneof"
                                                });
                                      })
                                  ]
                                ]),
                            tl: /* [] */0
                          }
                        }
                      },
                      (function (param) {
                          if (typeof param === "string") {
                            return Stdlib.failwith("Impossible case");
                          }
                          const variant = param.NAME;
                          if (variant === "Month") {
                            return 0;
                          } else if (variant === "Half") {
                            return 2;
                          } else {
                            return 1;
                          }
                        })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.year, param.kind);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(year, kind) {
  return {
          year: year,
          kind: kind
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.tax.control.v1.Period", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.year, param.kind);
  };
}

function constructor$1(year, kind) {
  return {
          year: year,
          kind: kind
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.tax.control.v1.Period", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Period, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Period"
        ]]
    }, V1, {
      Period: Period
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Period"
              ]]
          },
          "V1"
        ]]
    }, Control, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Period"
                    ]]
                },
                "V1"
              ]]
          },
          "Control"
        ]]
    }, Tax, {
      Control: Control
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [[
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "Period"
                          ]]
                      },
                      "V1"
                    ]]
                },
                "Control"
              ]]
          },
          "Tax"
        ]]
    }, Buhta, {
      Tax: Tax
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
